module.exports = __webpack_public_path__ + "img/SKMJ_sky1.5c6dd3c4.png";